import {
    Avatar,
    Button,
    Card,
    Col,
    DatePicker,
    Flex,
    Form,
    Image,
    Input,
    InputNumber,
    Modal,
    Row,
    Select,
    Tag,
    TimePicker,
    Typography,
  } from "antd";
  
  import React, { useEffect } from "react";
  import { CustomTitle } from "../../../../../common/customTitle";
  import { useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { useNavigate } from "react-router-dom";
  import { useTranslation } from "react-i18next";
  import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { colors } from "../../../../../../constants/colors";
import Title from "antd/es/typography/Title";
import { dateObjToDispViewDate, timeObjToDispViewTimeWithSuffix } from "../../../../../../utils/utils";
import dayjs from "dayjs";
import { getColorBasedOnStatus } from "./AppointmentsDetails";
import { GetCardLayout } from "../../../../../common/getCardLayout";
  
  const PackageServiceAppointmentDialog = ({ open, onClose, appointmentsInfoDetails }) => {
    /* i18n dependencies */
    const { t } = useTranslation();
    /* i18n dependencies */
  
    /* For navigating between pages */
    const navigate = useNavigate();
    /* For navigating between pages */
  
    /* dispatch an action */
    const dispatch = useDispatch();
    /* dispatch an action */
  
    /* login details */
    const { loginDetails } = useSelector((state) => state.auth);
    /* login details */
  
    /* form dependencies */
    const [form] = Form.useForm();
    const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
    /* form dependencies */
  
    /* loading dependencies */
    const [loading, setLoading] = useState(false);
    const [selectListLoader, setSelectListLoader] = useState(false);
    /* loading dependencies */
  
    /* dialog close dependencies */
    const handleDialogClose = () => {
      form.resetFields();
      onClose();
    };
    /* dialog close dependencies */
  
    return (
      <Modal
        open={open}
        onCancel={handleDialogClose}
        footer={false}
        confirmLoading={loading}
        width={800}
      >
        <Flex vertical gap="3rem" align="center" justify="center">
          <CustomTitle textDecoration="underline" justifyContent="center">
            {t("CommonUtils.appointmentInfo")}
          </CustomTitle>

            <Flex vertical gap="2rem">
              <Row gutter={[16, 16]}>
              <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.service")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_name
                        ? appointmentsInfoDetails?.service_name
                        : "-"}
                    </div>
                  </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.appointmentTime")}
                    required={false}
                  />
                  <div>
                    {appointmentsInfoDetails?.appointment_date_time
                      ? timeObjToDispViewTimeWithSuffix(
                          dayjs(
                            appointmentsInfoDetails?.appointment_date_time
                          )
                            .utc()
                            .local()
                            .format("ddd, MMM D, H:mm z")
                        )
                      : "-"}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.appointmentDate")}
                    required={false}
                  />
                  <div>
                    {dateObjToDispViewDate(
                      appointmentsInfoDetails?.appointment_date,
                      "ddmmyyyy"
                    )}
                  </div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.bookingFor")}
                    required={false}
                  />
                  <div>{appointmentsInfoDetails?.booking_for}</div>
                </Col>
                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.charges")}
                    required={false}
                  />
                  <div>{`${appointmentsInfoDetails?.service_price} ${systemSettings?.system_currency}`}</div>
                </Col>

                <Col span={8}>
                  <RequiredLabel
                    text={t("Modules.Appointments.charges")}
                    required={false}
                  />
                  <Tag
                    bordered={false}
                    style={getColorBasedOnStatus(appointmentsInfoDetails?.status)}
                    >
                    {appointmentsInfoDetails?.status}
                  </Tag>
                </Col>

                {(
                  <Col span={24}>
                    <Flex vertical gap="1rem">
                      <Typography.Title level={3}>
                        {t("Modules.Appointments.bookingForDetails")}
                      </Typography.Title>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <RequiredLabel
                            text={t("Modules.Appointments.name")}
                            required={false}
                          />
                          <div>{`${appointmentsInfoDetails?.booking_for_details?.first_name} ${appointmentsInfoDetails?.booking_for_details?.last_name}`}</div>
                        </Col>
                        <Col span={8}>
                          <RequiredLabel
                            text={t("Modules.Appointments.email")}
                            required={false}
                          />
                          <div>
                            {
                              appointmentsInfoDetails?.booking_for_details
                                ?.email
                            }
                          </div>
                        </Col>
                        <Col span={8}>
                          <RequiredLabel
                            text={t("Modules.Appointments.relationship")}
                            required={false}
                          />
                          <div>
                            {
                              appointmentsInfoDetails?.booking_for_details
                                ?.relationship
                            }
                          </div>
                        </Col>
                      </Row>
                    </Flex>
                  </Col>
                )}
              </Row>
            </Flex>

            {appointmentsInfoDetails?.service_provider_id &&
          appointmentsInfoDetails?.service_provider_id !== null &&
          appointmentsInfoDetails?.service_provider_id !== undefined && (
            <Card>
              <Flex vertical gap="2rem">
                <Typography.Title underline level={2}>
                  {t("CommonUtils.staffInfo")}
                </Typography.Title>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.profileImage")}
                      required={false}
                    />
                    {appointmentsInfoDetails?.service_provider_id
                      ?.profile_image ? (
                      <Image
                        style={{
                          width: "120px",
                          maxWidth: "100%",
                          border: "1px solid lightGray",
                          padding: "5px",
                          borderRadius: "10px",
                        }}
                        src={
                          appointmentsInfoDetails?.service_provider_id
                            ?.profile_image ?? "-"
                        }
                        alt={t("CommonUtils.profileImageAlt")}
                      />
                    ) : (
                      <>-</>
                    )}
                  </Col>

                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.staffName")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider_id
                        ? `${appointmentsInfoDetails?.service_provider_id?.first_name} ${appointmentsInfoDetails?.service_provider_id?.last_name}`
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.email")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider_id
                        ? appointmentsInfoDetails?.service_provider_id?.email
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.phoneNumber")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider_id
                        ? `+${appointmentsInfoDetails?.service_provider_id?.phone?.country_code}-${appointmentsInfoDetails?.service_provider_id?.phone?.phone_number}`
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.fees")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider_id
                        ? appointmentsInfoDetails?.service_provider_id?.fees
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.experience")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider_id
                        ? `${
                            appointmentsInfoDetails?.service_provider_id
                              ?.experience
                          } ${t("CommonUtils.experienceUnit")}`
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.availability")}
                      required={false}
                    />
                    <div>
                      <ol>
                        {appointmentsInfoDetails?.service_provider_id &&
                          appointmentsInfoDetails?.service_provider_id?.availability?.map(
                            (element) => {
                              return (
                                <li>{`${element.day} - ${element.startTime} to ${element.endTime}`}</li>
                              );
                            }
                          )}
                      </ol>
                    </div>
                  </Col>
                </Row>
              </Flex>
            </Card>
          )}
        </Flex>

      </Modal>
    );
  };
  
  export default PackageServiceAppointmentDialog;
  